import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthPanelService } from "../../../services/auth-panel.service";
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormHelperService } from "../../../services/form-helper.service";
import { DialogService } from 'src/app/services/dialog.service';
import { NavigateService } from 'src/app/services/navigate.service';

@Component({
  selector: 'panel-login',
  templateUrl: './panel-login.component.html',
  styleUrls: ['./panel-login.component.scss']
})
export class PanelLoginComponent {

  public formLogin: FormGroup;

  constructor(
    //private router: Router,
    private go: NavigateService,
    private authPanelService: AuthPanelService,
    public fh: FormHelperService,
    public formBuilder: FormBuilder,
    public dialog: DialogService
  ) {
    this.formLogin = this.fh.FormBuilder({
      email: { default: "" },
      password: { default: "" }
    });
  }

  public async loginPanel() {
    const form = this.formLogin.controls;
    let resposta = await this.authPanelService.loginPanel(form.email.value, form.password.value);
    if (!!resposta) {
      if (resposta.success) this.go.navigate({ route: ['panel'] }); else this.dialog.alert('Erro de Autenticação', 'Credenciais inválidas. Por favor, confira os dados e tente novamente.');
      //if(resposta.success) this.router.navigate(['/panel']); else this.dialog.alert('Erro de Autenticação','Credenciais inválidas. Por favor, confira os dados e tente novamente.');
    } else {
      this.dialog.alert('Erro desconhecido', 'Erro na comunicação com o servidor de autenticação!');
    }
  }

}
